import {REPORT_ELIGIBLE_ACCELERATOR_BONUS} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_ACCELERATOR_BONUS,
};
